import searchItemUrl from '../utils/searchItemUrl';

const recentSearchesItemTemplate = ({ children, query, html }) => {
	return html` <a class="aa-ItemLink" href=${searchItemUrl(query)}>
		${children}
	</a>`;
};

export default recentSearchesItemTemplate;
